import React from 'react'
import $ from 'jquery'
import { getTouchCoords, simulateMouseEvent } from '../../util/jqueryTouchSupport'
window.jQuery = $
require('jquery-ui-dist/jquery-ui')

const defaultClasses = {
  "ui-slider": "ui-corner-all",
  "ui-slider-handle": "ui-corner-all slider-range-custom",
  "ui-slider-range": "ui-corner-all ui-widget-header"
}

const RangeSlider = ({
  animate = false,
  classes = defaultClasses,
  disabled = false,
  max = 100,
  min = 0,
  orientation = 'horizontal',
  step = 1,
  defaultValues = ['', '',],
  handleIdPrefix = null,
  onMinChanged = () => {},
  onMaxChanged = () => {},
  filterResetSubscription = () => {},
}) => {
  const [sliderVals, setSliderVals] = React.useState(['', ''])
  const rangeEl = React.useRef(null)
  const touchObj = React.useRef({})
  
  const getSlider = () => {
    if (rangeEl) {
      return $(rangeEl.current)
    }
  }

  const changeSliderOption = (optionName, value) => {
    const $slider = getSlider()
    if ($slider) {
      $slider.slider('option', optionName, value)
    }
  }

  const setSliderValues = (values) => {
    const $slider = getSlider()
    if ($slider) {
      $slider.slider('values', values)
    }
  }

  // initial configuration and teardown
  React.useEffect(() => {
    const $slider = getSlider()
    if ($slider) {
      $slider.slider({
        animate,
        // classes,
        disabled,
        max,
        min,
        orientation,
        range : true,
        step,
        values: defaultValues,
        // slide is fired while sliders are moving
        // set the componenet slider state imperatively
        slide: function(event, ui) {
          setSliderVals(ui.values)
        },
        // change is fired when sliders stop moving
        // call parent change function when sliders settle
        change: function (event, ui) {
          if (ui.handleIndex === 0) {
            onMinChanged(ui.value)
          } else {
            onMaxChanged(ui.value)
          }
        }
      })
      // update component state with the initial values
      setSliderVals(defaultValues)
    }
    return () => {
      const $slider = getSlider()
      if ($slider) {
        $slider.slider('destroy')
      }
    }
  }, [])

  React.useEffect(() => {
    function resetFilter() {
      setSliderValues(defaultValues)
      setSliderVals(defaultValues)
      onMinChanged('')
      onMaxChanged('')
    }
    filterResetSubscription(resetFilter)
    return () => {
      filterResetSubscription(null)
    }
  }, [])

  // slider option hooks
  React.useEffect(() => changeSliderOption('animate', animate), [ animate, ])
  React.useEffect(() => changeSliderOption('classes', classes), [ classes, ])
  React.useEffect(() => changeSliderOption('disabled', disabled), [ disabled, ])
  React.useEffect(() => changeSliderOption('max', max), [ max, ])
  React.useEffect(() => changeSliderOption('min', min), [ min, ])
  React.useEffect(() => changeSliderOption('orientation', orientation), [ orientation, ])
  React.useEffect(() => changeSliderOption('step', step), [ step, ])
  // React.useEffect(() => changeSliderOption)


  return <>
    <div id={'slider-range'} ref={rangeEl} 
      onTouchStart={(e) => {
        e.persist()
        touchObj.current.startMove = e.timeStamp
        touchObj.current.startPos = getTouchCoords(e)
        simulateMouseEvent(e, 'mouseover')
        simulateMouseEvent(e, 'mousemove')
        simulateMouseEvent(e, 'mousedown')
      }} 
      onTouchMove={(e) => {
        simulateMouseEvent(e, 'mousemove')
        touchObj.current.touchedMoved = true
      }}
      onTouchEnd={(e) => {
        simulateMouseEvent(e, 'mouseup')
        simulateMouseEvent(e, 'mouseout')

        let timeMoving = e.timeStamp - touchObj.current.startedMove
        if (!touchObj.current.touchMoved || timeMoving < 500) {
          // Simulate the click event
          simulateMouseEvent(e, 'click')
        } else {
          var endPos = getTouchCoords(e)
          if ((Math.abs(endPos.x - touchObj.current.startPos.x) < 10) && (Math.abs(endPos.y - touchObj.current.startPos.y) < 10)) {

            // If the touch interaction did not move, it should trigger a click
            if (!touchObj.current.touchMoved || e.originalEvent.changedTouches[0].touchType === 'stylus') {
              // Simulate the click event
              simulateMouseEvent(e, 'click')
            }
          }
        }
      }}
    >
      {/* 
          only include handles if there's a custom id specified.
          otherwise styling them is not going to work.
       */}
      { handleIdPrefix && <span id={`${handleIdPrefix}-min`} className={'ui-slider-handle slider-range-custom'}>${sliderVals[0]}</span> }
      { handleIdPrefix && <span id={`${handleIdPrefix}-max`} className={'ui-slider-handle slider-range-custom'}>${sliderVals[1]}</span> }
    </div>
  </>
}

export default RangeSlider